import React, { useRef, useEffect, useState } from 'react'
import { motion, useInView } from 'framer-motion'
import Overview from '../../../assets/images/projectportfolio/overview.webp'
import colors from '../../theme/color';
const textContent = `This project is a modern, full-scale eCommerce platform built to deliver a seamless & consistent shopping experience across web and mobile devices. It focuses on intuitive product discovery, smooth navigation, and fast performance, ensuring users can browse, compare, & purchase products effortlessly. The interface is designed with a clean and minimal aesthetic, making it easy for users to interact with complex features like filtering, order tracking, and account management without friction.`

const words = textContent.split(' ')

const OverviewSection = () => {
  const ref = useRef(null)
  const inView = useInView(ref, { margin: '-100px' })

  const [ setVisibleCount] = useState(0)

  // 👇 Detect scroll direction
  const [lastScroll, setLastScroll] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY

    
      setLastScroll(currentScroll)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [inView, lastScroll])

  return (
    <section
      ref={ref}
      className="w-full max-w-[90%] mx-auto text-white border-t border-[#FFFFFF1A] pt-20"
    >
      {/* HEADER */}
      <div className="flex items-center justify-center gap-4 mb-16">

        {/* LEFT LINE */}
        <motion.div
          className="flex items-center -gap-2 mt-4"
          initial={{ x: -150, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.6, ease: 'easeIn' }}
        >
          <span
  className="w-2 h-2 rounded-full"
  style={{ backgroundColor: colors.portfolioGreen }}
></span>
          <div className="w-12 md:w-30 h-[1px] bg-gray-100"></div>
        </motion.div>

        {/* HEADING */}
        <motion.h2
          className="text-3xl md:text-5xl lg:text-6xl font-bold font-gilroy "
          style={{ color: colors.portfolioGreen }}
          initial={{ scale: 0.6, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: 'easeIn' }}
        >
          Overview
        </motion.h2>

        {/* RIGHT LINE */}
        <motion.div
          className="flex items-center -gap-2 mt-4"
          initial={{ x: 150, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.6, ease: 'easeIn' }}
        >
          <div className="w-12 md:w-30 h-[1px] bg-gray-100"></div>
          <span
  className="w-2 h-2 rounded-full"
  style={{ backgroundColor: colors.portfolioGreen }}
></span>
        </motion.div>

      </div>

      {/* CONTENT */}
      <div className="flex flex-col md:flex-row items-stretch md:gap-12 lg:gap-10">

        {/* IMAGE */}
        <motion.div
  className="w-full lg:w-1/2 flex justify-center items-center"
  initial={{ x: -250, opacity: 0 }}
  whileInView={{ x: 0, opacity: 1 }}
  viewport={{ once: false }}
  transition={{ duration: 1.2, ease: 'easeIn' }}
>
  <motion.img
    src={Overview}
    alt="Overview"
    className="w-full object-contain drop-shadow-[0_0_20px_rgba(143,230,74,0.1)]"
    animate={{
      rotate: [-3, 3, -3],
    }}
    transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut',
    }}
  />
</motion.div>

        {/* TEXT */}
        <div className="w-full lg:w-2/3 flex items-center justify-center lg:justify-start font-gilroy-medium">
  
  <motion.div
    initial={{ x: 100, opacity: 0 }}
    whileInView={{ x: 0, opacity: 1 }}
    viewport={{ once: false }}
    transition={{ duration: 0.9, ease: 'easeIn' }}
  >
    <p className="text-gray-300 text-base md:text-base lg:text-2xl xl:text-2xl 2xl:text-3xl  md:leading-[1.5] lg:leading-[1.5] xl:leading-[1.8] 2xl:leading-[2] text-left">
    This project is a modern, full-scale eCommerce platform built to deliver a seamless & consistent shopping experience across web and mobile devices. It focuses on intuitive product discovery, smooth navigation, and fast performance, ensuring users can browse, compare, & purchase products effortlessly. The interface is designed with a clean and minimal aesthetic, making it easy for users to interact with complex features like filtering, order tracking, and account management without friction.
    </p>
  </motion.div>

</div>

      </div>
    </section>
  )
}

export default OverviewSection